import { useQuery } from '@tanstack/react-query'

import { getAccountId, isAdvertiser } from '~/helpers'

import {
  getAdvertiserConfigurationKey,
  getAdvertiserConfigurationService
} from '../services/configuration/advertiser'

// Gate de exibição de NTB por conta de anunciante (rollout opt-in; sem flag → oculto)
export function useNtbMetricsGate() {
  const { data, isPending } = useQuery({
    enabled: isAdvertiser(),
    // a flag é por conta, e o `queryClient` sobrevive à troca de conta
    queryKey: [getAdvertiserConfigurationKey, getAccountId()],
    queryFn: async () => {
      const response = await getAdvertiserConfigurationService()

      return response.data?.configuration ?? { allow_ntb_metrics: false }
    },
    staleTime: 5 * 60 * 1000
  })

  return { isEnabled: !!data?.allow_ntb_metrics, isPending }
}

export function useNtbMetricsEnabled(): boolean {
  return useNtbMetricsGate().isEnabled
}
